<div class="component-container">
  <h2 *ngIf="isPending" class="mb-2">Connect Integrations for {{ brandName }}</h2>

  <shared-integrations
    *ngIf="isPending"
    [advertiser]="advertiser"
    [brand]="brand"
    [availableIntegrations]="availableIntegrations"
    [anonIntInvite]="anonInvite"
    [tag]="brandTag"
  >
  </shared-integrations>

  <mat-card *ngIf="!isPending" fxLayoutAlign="center center">
    <p>
      This invite has expired. Please contact
      <a href="mailto:customersuccess@myadvocado.com" target="_blank">customersuccess@myadvocado.com</a>
      if you think this is a mistake.
    </p>
  </mat-card>
</div>
